import React, { useState } from "react";
import { Plus, X } from "lucide-react";

// Import local components
import "../css-coding/aboutmain.css";
import AboutUsPage from "./AboutUsPage";
import FounderPage from "./FoundersPage";
// import OurStoryPage from "./OurStoryPage";
import ChallengesResolved from "./ChallengesResolved";
// import MissionVisionPage from "./MissionVisionPage";
import WhyChooseUsPage from "./WhyChooseUsPage";
import OurBrandMantraPage from "./OurBrandMantraPage";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

// --- Accordion Item Component ---
const AccordionItem = ({ title, isOpen, onToggle, isFirst, isLast, content }) => {
  return (
    <div className={`accordion-item ${isOpen ? "open" : ""}`}>
      {/* Timeline Dot */}
      {!isFirst && <span className="timeline-dot"></span>}

      {/* Timeline Line */}
      {!isLast && <span className={`timeline-line ${isFirst ? "first" : ""}`}></span>}

      {/* Accordion Header */}
      <button
        className={`accordion-header ${isOpen ? "open" : ""}`}
        onClick={onToggle}
      >
        <div className="header-text">
          <h3 className={`title ${isOpen ? "open" : ""}`}>{title}</h3>
        </div>

        {/* Toggle Icon */}
        <div className="header-icon">
          {isOpen ? <X size={20} strokeWidth={3} /> : <Plus size={20} strokeWidth={3} />}
        </div>
      </button>

      <div className={`accordion-content ${isOpen ? "open" : ""}`}>
        <div className="content-inner">
          {/* Render the passed content (string or JSX) */}
          {typeof content === "string" ? <p>{content}</p> : content}
        </div>
      </div>
    </div>
  );
};

const Aboutmain = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Dropdown Titles only
  const accordionTitles = [
  "Mentor & YouTuber (April 2021 - July 2023)",
  "Finding My Voice & Adding a Personal Touch (April 2021 - July 2023)",
   "Senior Video Editing & Production Leadership (July 2023 - September 2024)",
    "Professional Freelancing & Digital Entrepreneurship (September 2024 - April 2025)",
    "Founder & CEO, The Growth Secret Media (April 2025 - Present)",
  
  ];

  // Different "hello welcome" content for every dropdown
  const accordionContents = [
      (
    <div>
      <p>
        It all began on YouTube, where I started creating tech and mobile editing tutorials. 
        I shared MY knowledge from behind the scenes, using only my voice to build a community.
      </p>
      <br></br>
      <p>
       My focus is simple: build trust and provide real value through consistent, helpful content 
        that my audience loved.
      </p>
    </div>
  ),
    (
    <div>
      <p>
     
As I grew, I stepped in front of the camera. I transitioned to creating PC video editing tutorials and tech reviews, finally putting a face to the voices my community had come to trust.
      </p>
      <br></br>
      <p>
       This personal connection helped deepen my audience engagement and expand my channel’s reach, proving that authenticity is key.
      </p>
    </div>
  ),  (
    <div>
      <p>
      I took my skills to the next level, working as Senior Video Editor at Kayteegee Adtech. Here, I managed the entire video production process, from client shoots to final edits.

      </p>
      <br></br>
      <p>
       I developed content strategies, handled camera work, and worked closely with clients to improve their digital branding and online visibility, ensuring every project was delivered on time and to the highest standard.
      </p>
    </div>
  ),  (
    <div>
      <p>
      With a wealth of experience, we transitioned into the world of professional freelancing, specializing in video editing, content creation, and online education.
      </p>
      <br></br>
      <p>
       
I had the privilege of working with over 100 clients and completing more than 900 projects, building a strong portfolio and a solid reputation in the digital space.
      </p>
    </div>
  ),
   
   (
   <div>
      <p>
      With a shared vision, I launched The Growth Secret Media, a modern creative agency specializing in video editing, motion graphics, and personal branding.
      </p>
      <br></br>
      <p>
       

Today, I'm proud to be a trusted partner for creators, entrepreneurs, and coaches, having served over 150 clients. We are dedicated to helping you build a powerful online identity by turning your content into a credible, authoritative brand.
      </p>
      <br></br>
      <p>
        We offer end-to-end content solutions, from Instagram Reels to YouTube videos and full coaching course production, blending creative storytelling with business strategy to help you grow.
      </p>
    </div>
    )
  

  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="app">
        {/* --- Top About Section --- */}
        <AboutUsPage />

        {/* --- Accordion Timeline Design --- */}
        <div className="accordion-container">
          {accordionTitles.map((title, index) => (
            <AccordionItem
              key={index}
              title={title}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
              isFirst={index === 0}
              isLast={index === accordionTitles.length - 1}
              content={accordionContents[index]}
            />
          ))}
        </div>
      </div>

      {/* The rest of your pages (kept outside the accordion as before) */}
      <FounderPage />
      {/* <OurStoryPage /> */}
      <ChallengesResolved />
      {/* <MissionVisionPage /> */}
      <WhyChooseUsPage />
      <OurBrandMantraPage />
      <ContactSection />
      <Footer />
    </>
  );
};

export default Aboutmain;
 